// NATIVE 
import * as React from 'react';


// INSTALLED 
import { Grid } from '@mui/material';
import { Formik, Form } from 'formik';
import { useDispatch } from 'react-redux';
import Dialog from '@mui/material/Dialog';
import Button from '@mui/material/Button';
import { styled } from '@mui/material/styles';
import IconButton from '@mui/material/IconButton';
import CloseIcon from '@mui/icons-material/Close';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';


// CUSTOM 
import { SnackAlert } from '../../SnackAlert';
import { timeToClosedToast } from '../../../commons';
import MultipleSnackbars from '../../MultipleSnackbars';
import { closeSessionGlobal } from '../../../commons/utils';
import { storeEditParameter } from '../../../store/parameters';
import { EditParameter } from '../../parametros/editar/EditParameter';
import { ModalSessionExpired } from '../../generics/ModalSessionExpired';
import validationSchema from '../../parametros/formModels/editar/validationSchema';
import formInitialValues from '../../parametros/formModels/editar/formInitialValues';
import editParameterFormModel from '../../parametros/formModels/editar/editParameterFormModel';




const BootstrapDialog = styled(Dialog)(({ theme }) => ({
  '& .MuiDialogContent-root': {
    padding: theme.spacing(2),
  },
  '& .MuiDialogActions-root': {
    padding: theme.spacing(1),
  },
}));

export const EditDialogParameter = (props:any) =>  {

 

  const{ open, handleCloseModalEditarParameter, buttons = false } = props;



  const dispatch = useDispatch();

  const { formId, formField } = editParameterFormModel;

  const currentValidationSchema = validationSchema[0];

  

  const [percentaje_area, setPercentajeArea] = React.useState(0);
  const [data, setMsgErrors] = React.useState([]);
  const [alert_snack, setAlertSnack] = React.useState(false);

  const [messagesAlerts, setMessagesAlerts] = React.useState<string[]>([]); 

  const  [isSubmitting, setIsSubmitting] = React.useState(false);
  const  [btnText, setBtnText] = React.useState('Editar Parametro');

  const [timeAlert, setTimeAlert] = React.useState(timeToClosedToast);
  const [modalSessionExpired, setModalSessionExpired] = React.useState<boolean>(false);

  const [msgSnack, setMsgSnack] = React.useState({
      msg: '',
      status: 'success'
  });

  
  const handleClose = () => {
    handleCloseModalEditarParameter(false);
  };


  const _handleSubmit = async(values:any, actions:any) => {



    
    setIsSubmitting(true);
    actions.setSubmitting(true);
    setBtnText('Un Monento...')

    const response = await dispatch( storeEditParameter(values) );


    setIsSubmitting(false);
    actions.setSubmitting(false);
    setBtnText('Editar Parametro')

    const result =  await validateResponse(response, ' (Editar Parametro. )');

    if (!result) {
        return false;
    }

    if (response.ok) {
        

      const message:any = {
        msg: response.message,
        status: 'success'
      };
    
      await setMsgSnack(message);
      await setAlertSnack(true);

      actions.resetForm();
      actions.setSubmitting(false);
      handleCloseModalEditarParameter(false);

    }
    
    

  }
  


  const validateResponse = async(response:any, textActionConcat: string) => {
        
        
          if (  response.code == 401  ) {
            await localStorage.removeItem('lastSelectedQypht');
            await closeSessionGlobal();
            await handleCloseModalEditarParameter(false);
            setModalSessionExpired(true);
            return false;
          }
  
        
          // 403 NO TIENE PERMISSO PARA REALIZAR ESA ACCION 
  
          if (!response.ok && response.code == 403 ) { 

            const errors:any = {
                msg: response.errors[0]+' '+textActionConcat,
                status: 'error'
            };
            
            await setMsgSnack(errors);
            await setAlertSnack(true);
  
            return false;
          }
          



          // 403 EL DATO YA SE ENCUENTRA REGISTRADO
        if (!response.ok && response.code == 409 ) { 
    
          const errors:any = {
              msg: response.errors[0]+' '+textActionConcat,
              status: 'error'
          };
          
          await setMsgSnack(errors);
          await setAlertSnack(true);

          return false;
        }
  
          
          // 400 ERROR EN DATOS ENVIADOS MAYORMENTE PROPIEDAD INVALIDA O MAL FORMATEADO 
          if (!response.ok && response.code == 400 ) { 
  
            const errors:any = [];
  
            response.errors.forEach( (element:any) => {
                
                errors.push({
                  type: 'error',
                  text: element
                })
            });
  
              
            setMessagesAlerts(errors);
            return false;
  
          }
  
          return true;
        
  }
  

  return (
    <React.Fragment>


      <ModalSessionExpired  open={modalSessionExpired}  />
      <MultipleSnackbars messagesList={messagesAlerts} position={"bottom-left"} autoClose={timeAlert} />

      <SnackAlert open={alert_snack} onclick={setAlertSnack} text={msgSnack.msg} severity={msgSnack.status}/>
      
      <BootstrapDialog
        onClose={handleClose}
        aria-labelledby="customized-dialog-title"
        open={open}
        fullWidth={true}
      >
        <DialogTitle sx={{ m: 0, p: 2 }} id="customized-dialog-title">
           Editar Parametros
        </DialogTitle>
        <IconButton
          aria-label="close"
          onClick={handleClose}
          sx={{
            position: 'absolute',
            right: 8,
            top: 8,
            color: (theme) => theme.palette.grey[500],
          }}
        >
          <CloseIcon />
        </IconButton>
        <DialogContent dividers>
        
   
        <Grid  >
        <Formik 
              initialValues={formInitialValues}
              validationSchema={currentValidationSchema}
              onSubmit={_handleSubmit}>

              <>
              <Form id={formId}>
                <EditParameter formField={formField}/>

                <Button
                    disabled={isSubmitting}
                    style={{margin:5, float: 'right'}}
                    type="submit"
                    variant="contained"
                    color={ "primary"}
                  >
                    {
                      btnText
                    }
                    
                </Button>
                </Form>
              </>

            </Formik>
        </Grid>
       
        </DialogContent>
        <DialogActions>
        </DialogActions>
      </BootstrapDialog>
    </React.Fragment>
  );
}




